import React from "react"

export type AppointmentsTrackingEvent =
  | { type: "APPOINTMENTS_PAGE_VIEWED" | "SEND_A_MESSAGE_CLICKED" }
  | {
      type: "JOIN_CLICKED" | "CANCEL_STARTED"
      appointmentId: string
    }
  | {
      type: "CANCEL_CONFIRMED" | "CANCEL_SUCCEEDED" | "CANCEL_FAILED"
      appointmentId: string
      cancellationAttemptId: string
    }

let cancellationAttemptSequence = 0
export const createCancellationAttemptId = (): string => `${Date.now()}-${++cancellationAttemptSequence}`

export type TrackAppointmentsEvent = (event: AppointmentsTrackingEvent) => void

export const untrackedAppointmentsEvent: TrackAppointmentsEvent = () => undefined
export const AppointmentsTrackingContext = React.createContext<TrackAppointmentsEvent>(untrackedAppointmentsEvent)

export const useAppointmentsTracking = () => React.useContext(AppointmentsTrackingContext)
